import profileRequest from '@stelecom/ui-react/components/requests/profileRequestIntegration';
import { TResponse, captureQueryError } from '~/src/api/helper';
import { IReceipt } from '~/src/store/reducers/auth';

type TGetReceiptResponse = TResponse<Blob, any>
type TGetReceiptJSON = TResponse<IReceipt, any>

export async function getReceipt(domain: string, accessToken: string, sms = false, isDownload = false): Promise<TGetReceiptResponse> {
    try {
        const resp = await profileRequest(domain, accessToken).get('/receipt/pdf', {
            params: {
                sms: Number(sms),
                isDownload: Number(isDownload),
            },
            responseType: 'blob',
        });
        return {
            isSuccess: true,
            payload: resp.data,
        };
    } catch (e) {
        return captureQueryError(e);
    }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getReceiptJSON = async(domain: string, accessToken: string): Promise<TGetReceiptJSON | undefined> => {
    // @ts-ignore
    // return rec;
    try {
        const resp = await profileRequest(domain, accessToken).get('/receipt/receipt-json');
        return resp.data;
    } catch (e) {
        captureQueryError(e);
    }
};

